import { useCallback, useEffect, useState } from 'react';

import { PERCENTAGES_COMPLETED } from './VehicleProfilingHub.constants';
import { useVehicleProfilingSections } from './VehicleProfilingHub.hooks';

export const useGlobalProgress = (): number => {
  const { sections } = useVehicleProfilingSections();

  const calculateGlobalProgress = useCallback(() => {
    const result = Object.values(sections)
      .reduce((acc, { partOfGlobalProgress }) => acc + partOfGlobalProgress, 0);

    // we don't want to show 100% progress when all sections are completed
    return result === PERCENTAGES_COMPLETED ? PERCENTAGES_COMPLETED - 1 : result;
  }, [sections]);

  const [globalProgress, setGlobalProgress] = useState(calculateGlobalProgress() || 0);

  useEffect(() => {
    setGlobalProgress(calculateGlobalProgress());
  }, [calculateGlobalProgress, sections]);

  return globalProgress;
};
